<template>
  <div class="pay">
    <el-dialog title="选择支付方式"
               :visible.sync="dialogVisible"
               width="768px"
               :before-close="handleClose">
      <div class="main">
        <h4 v-if="type=='shop'">
          共计：<span>￥{{  this.total_amount}}</span>
        </h4>
        <h4 v-else>
          共计：<span>￥{{ pay_amount}}</span>
        </h4>
        <!--   <h4 v-else>
                    共计：<span>￥{{ type == "class" ? all_price : total_amount }}</span>
                </h4> -->
        <el-form :model="ruleForm"
                 ref="ruleForm"
                 label-width="140px"
                 class="demo-ruleForm">
          <el-form-item label="类目名称："
                        v-if="rowInfo != null">
            <p class="red">{{ `${rowInfo.level[0].top_name}>${rowInfo.level[0].parent_name}>${rowInfo.level[0].name}` }}</p>
          </el-form-item>
          <el-form-item label="申请店铺类型："
                        prop="type"
                        v-if="type == 'shop'">
            <p>{{ shop_name }}</p>
          </el-form-item>
          <!-- <el-form-item label="支付类型：" prop="pay_type">
                        <el-radio-group v-model="ruleForm.pay_type" @change="typeChange">
                            <el-radio label="1">线上支付</el-radio>
                            <el-radio label="2">线下支付</el-radio>
                        </el-radio-group>
                    </el-form-item> -->
          <!-- <el-form-item v-if="ruleForm.pay_type == 2">
                        <el-upload
                            action="#"
                            list-type="picture-card"
                            :auto-upload="false"
                            :file-list="ruleForm.file"
                            :class="ruleForm.file.length == 1 ? 'mf' : ''"
                            :on-change="(file, fileList) => handleChange(file, fileList, 0)"
                            :on-remove="(file, fileList) => handleRemove(file, fileList, 0)"
                        >
                            <i slot="default" class="el-icon-plus"></i>
                        </el-upload>
                    </el-form-item> -->
          <el-form-item label="支付方式："
                        prop="code"
                        v-if="ruleForm.pay_type == 1">
            <el-radio-group v-model="ruleForm.code"
                            @change="codeChange"
                            :disabled="opt">
              <el-radio label="WeChat">微信</el-radio>
              <el-radio label="AliPay"> 支付宝</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label=""
                        class="right"
                        v-if="ruleForm.pay_type == 1">
            <div class="img">
              <div class="div"
                   style="width: 140px; height: 140px"
                   v-loading="urlLoad"
                   element-loading-text="加载中"
                   element-loading-spinner="el-icon-loading"
                   element-loading-background="rgba(0, 0, 0, 0.8)">
                <vue-qr :text="qrUrl"
                        qid="testid"
                        :margin="0"
                        v-if="qrUrl || show"></vue-qr>
              </div>
            </div>
          </el-form-item>
        </el-form>
      </div>

      <span slot="footer"
            class="dialog-footer">
        <el-button @click="handleClose"
                   type="primary">关 闭</el-button>
      </span>
    </el-dialog>
    <div v-if="payVisible">
      <payResult @handleClose='inithandleClose'
                 :title='title'
                 ></payResult>
    </div>
  </div>

</template>

<script>
import { mapActions, mapGetters } from "vuex";
import VueQr from "vue-qr";
import payResult from './payDetails.vue'
export default {
  data () {
    return {
      dialogVisible: false,
      urlLoad: false,
      qrUrl: "",
      ruleForm: {
        type: "",
        pay_type: "1",
        code: "WeChat",
        file: [],
        image: "",
      },
      timer: null,
      show: false,
      opt: false,
      ids: "",
      all_price: 0,
      type: "",
      rowInfo: null,
      shop_name: "",
      pay_amount: '',
      title: '',
      payVisible:false

    };
  },
  components: { VueQr,payResult },
  props: ["total_amount", "category_id", "shop_id"],
  computed: {
    ...mapGetters(["getToken"]),
  },
  updated () {
    console.log(this.rowInfo, 'this.rowInfo-----', this.type)
  },
  methods: {
    inithandleClose(){
  this.payVisible = false
},
    ...mapActions({
      uploadFile: "commodity/uploadFile", //  图片上传
      storeapplyPay: "detect/storeapplyPay",
      getPayment: "activity/getPayment",
      getPayQuery: "activity/getPayQuery",
      categoryRecharge: "detect/categoryRecharge",
    }),
    onSubmit () {
      this.show = true;
      this.urlLoad = true;
      if (this.type == "class") {
        let params = {
          token: this.getToken,
          shop_id: this.shop_id,
          category_id: this.ids,
          code: this.ruleForm.code,
        };
        this.categoryRecharge(params).then(({ data }) => {
          if (data.code == 1) {
            this.Pay(data.data.order_id);
            this.pay_amount = data.data.pay_amount
            console.log(data.data.pay_amount, 'data.data.pay_amount')

          } else {
            this.$message.error(data.msg);
            this.show = false;
            this.urlLoad = false;
          }
        });
      } else if (this.type == "thaw") {
        let params = {
          shop_id: this.shop_id,
          category_id: this.rowInfo.ids,
          code: this.ruleForm.code,
          token: this.getToken,
        };
        this.categoryRecharge(params).then(({ data }) => {
          if (data.code == 1) {
            this.Pay(data.data.order_id);
            this.pay_amount = data.data.pay_amount
          } else {
            this.$message.error(data.msg);
            this.show = false;
            this.urlLoad = false;
          }
        });
      } else if (this.type == "shop") {
        let params = {
          shop_id: this.shop_id,
          user_merchant_id: this.$getSessionStorage("userid"),
          pay_type: 1,
          amount: this.total_amount,
    /*       category_id: this.category_id, */
          code: this.ruleForm.code,
          token: this.getToken,
        };
        this.storeapplyPay(params).then(({ data }) => {
          if (data.code == 1) {
            if (data.data==2) {
               this.title = '支付成功' 
             this.payVisible = true
            }else{
                this.Pay(data.data);
            this.pay_amount = data.data.pay_amount
            }
                   
          } else {
            this.$message.error(data.msg);
            this.show = false;
            this.urlLoad = false;
          }
        });
      } else if (this.type == "pay") {
        let params = {
          shop_id: this.shop_id,
          user_merchant_id: this.$getSessionStorage("userid"),
          pay_type: 1,
          amount: this.total_amount,
          category_id: this.rowInfo.id,
          code: this.ruleForm.code,
          token: this.getToken,
        };
        this.storeapplyPay(params).then(({ data }) => {
          if (data.code == 1) {
             if (data.data==2) {
               this.title = '支付成功' 
             this.payVisible = true
            }else{
                this.Pay(data.data);
            this.pay_amount = data.data.pay_amount
            }
            /* this.Pay(data.data); */
          } else {
            this.$message.error(data.msg);
            this.show = false;
            this.urlLoad = false;
          }
        });
      }
    },
    checkPay (id) {
      let opt = {
        id: id,
        token: this.getToken,
      };
      this.getPayQuery(opt).then(({ data }) => {
        if (data.code == 1) {
          if (data.data.status == 2) {
            clearInterval(this.timer);
            this.title = '支付成功'
            this.dialogVisible = false;
             this.payVisible = true
            this.$emit("init");
          } else if (data.data.status == 3) {
            clearInterval(this.timer);
            this.title = '支付失败'
             this.payVisible = true
               this.dialogVisible = false;
          }
        }
      });
    },
    Pay (id) {
      this.opt = true;
      this.getPayment({ id: id }).then(({ data }) => {
        this.opt = false;
        clearInterval(this.timer);
        this.urlLoad = false;
        if (data.code == 1) {
          this.qrUrl = data.data.pay_url;
          if (!data.data.pay_url) {
            this.$message.warning("已提交过申请，请等待审核！");
            this.imgDialog = false;
          } else {
            this.qrUrl = data.data.pay_url;
            this.urlLoad = false;
            let i = 0;
            this.timer = setInterval(() => {
              this.checkPay(id);
              i++;
              if (i >= 20) {
                clearInterval(this.timer);
              }
            }, 3000);
          }
        } else {
          this.$message.error(data.msg);
        }
      });
    },
    handleClose () {
      this.ruleForm = {
        type: "",
        pay_type: "1",
        code: "WeChat",
        file: [],
        image: "",
      };
      this.dialogVisible = false;
      clearInterval(this.timer);
      this.urlLoad = false;
      this.qrUrl = "";
      this.show = false;
      this.type = "";
      this.rowInfo = null;
      this.shop_name = "";
    },
    codeChange () {
      this.onSubmit();
    },
    handleChange (file, fileList, index, talent_id) {
      var formdata = new FormData();
      formdata.append("formdata", file.raw);
      switch (index) {
        case 0:
          this.ruleForm.file = fileList;
          break;
        default:
          break;
      }
      this.uploadFile(formdata).then((res) => {
        if (res.code == 1) {
          // console.log(res);
          this.$message.success("上传成功！");
          switch (index) {
            case 0:
              this.ruleForm.url = res.data.formdata_details[0].urls;
              break;
            default:
              break;
          }
        } else {
          this.$message({
            type: "warning",
            message: res.msg,
          });
        }
      });
    },
    //文件删除
    handleRemove (file, fileList, index) {
      switch (index) {
        case 0:
          this.ruleForm.file = [];
          break;
        default:
          break;
      }
    },
  },
  beforeDestroy () {
    clearInterval(this.timer);
  },
};
</script>

<style lang="scss" scoped>
.main {
  height: 400px;
  h4 {
    text-align: center;
    font-size: 20px;
    font-weight: bold;
    color: #333333;
    line-height: 56px;
    margin-bottom: 20px;
    span {
      font-size: 20px;
      font-weight: bold;
      color: #f60a0a;
    }
  }
}
.right {
  flex: 1;
  display: flex;
  align-items: center;
  .img {
    img,
    .el-image {
      width: 140px;
      height: 140px;
      background: #eee;
      font-size: 36px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  .price_right {
    text-align: left;
    h4 {
      font-size: 18px;
      margin-bottom: 14px;
      span {
        font-size: 24px;
      }
    }
    p {
      padding-left: 4px;
      font-size: 14px;
    }
  }
}
.mf {
  ::v-deep .el-upload--picture-card {
    display: none !important;
  }
}
</style>